import { GET_USER_REGISTRATION_DATA, SAVE_USER_DATA } from '../../../../constants/system/actions';

const getUserRegistrationData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: GET_USER_REGISTRATION_DATA, payload, resolve, reject,
});

const saveUserData: Function = (payload?: ActionPayload, resolve?: Function, reject?: Function): ReduxAction => ({
  type: SAVE_USER_DATA, payload, resolve, reject,
});

export {
  getUserRegistrationData,
  saveUserData,
};
